var map = {
	"../pages/admin/admin.module": [
		1296,
		15
	],
	"../pages/admin/users/users.module": [
		1297,
		14
	],
	"../pages/coin/coin.module": [
		1298,
		13
	],
	"../pages/coins/coins.module": [
		1300,
		12
	],
	"../pages/dashboard/dashboard.module": [
		1299,
		1
	],
	"../pages/exchanges/exchanges.module": [
		1301,
		11
	],
	"../pages/glossary/glossary.module": [
		1302,
		10
	],
	"../pages/guides/guides.module": [
		1303,
		9
	],
	"../pages/login/login.module": [
		1305,
		0
	],
	"../pages/news/news.module": [
		1304,
		8
	],
	"../pages/portfolio/portfolio.module": [
		1307,
		7
	],
	"../pages/prime/prime.module": [
		1306,
		6
	],
	"../pages/pulse/pulse.module": [
		1311,
		5
	],
	"../pages/tutorial/tutorial.module": [
		1308,
		4
	],
	"../pages/user-settings/user-settings.module": [
		1309,
		3
	],
	"../pages/watchlist/watchlist.module": [
		1310,
		2
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 388;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 388
// module chunks = 16